require('./notification/index');
require('./notification/notification');

require('./address/index');
require('./address/city_select');
require('./fullcalendar');
require('./schedule');
import { Chart, registerables } from 'chart.js';
Chart.register(...registerables);
require('./charts');
require('./multitem');
require('./categoryapi');
require('./systemapi');
require('./subsystemapi');
require('./../jquery_extensions');
require('./serviceprovider/index');
require('./preventivemaintenanceapi');

// $('.flipswitch').each(function(){
//     $(this).click(function(){
//         $(this).toggleClass("bg-success");
//     });
//
// });

setInterval(function () {
    $(".alert-item-menu").toggleClass("alert-text-red");
    $(".img-alert").toggleClass("alert-text-red");
}, 1000);

$(".chart_condominios_previstcheck").each(function (item) {
    const values = [$(this).attr("previst"), $(this).attr("check")];

    const myChart = new Chart($(this), {
        type: 'bar',
        data: {
            labels: ['Previsto', 'Realizado'],
            datasets: [{
                label: 'Checagem Manut.',
                data: values,
                backgroundColor: [
                    'blue',
                    'green'

                ]
            }]
        },
        options: {
            responsive: true,
            legend: { display: false },
            labels: {

            },
            title: {
                display: false,
                text: "World Wine Production 2018"
            },
            plugins: {
                legend: {
                    display: false
                }
            },
            scales: {
                y: {
                    display: false
                },
                x: {
                    display: false
                }
            }
        }
    });
});

$("#preventive_maintenance_id").change(function () {
    if ($(this).val() > 0) {
        $(".btn-add-preventivem").prop("disabled", false);
    } else {
        $(".btn-add-preventivem").prop("disabled", true);

    }
});
$(".btn-select-all").click(function () {
    $(".item-check").each(function () {
        $(this).prop("checked", "checked");
    });
});

$(".multselect").select2();

$(".multselect").on('change', function (e) {
    $("form").submit();
});

$(".multselect_image").select2({
    templateResult: formatState,
    templateSelection: formatState,
    selectOnClose: false
});


function formatState(opt) {
    if (!opt.id) {
        return opt.text;
    }
    let optimage = URL("/images/default_image.png");
    if (!optimage) {
        // This is safe, since you're returning a string
        return opt.text;
    } else {
        // Create an individual image element to properly escape the src url

        if (opt.text.split("#")[1].length > 0)
            optimage = opt.text.split("#")[1];

        // And remember to escape the text we're outputing
        const $opt = $(
            '<span><img src="' + optimage + '" style="width:25px;height: 25px;;object-fit: cover;border-radius: 5px;margin: 3px;" /> ' + opt.text.split("#")[0] + '</span>'
        );

        return $opt;
    }
};

function URL(urlpath) {
    let url = "";
    url += window.location.protocol + "//";
    url += window.location.hostname;
    const porta = window.location.href
        .replace(window.location.protocol + "//", '')
        .replace(window.location.pathname, '')
        .replace(window.location.hostname, '')
        .replace(":", "");

    if (!isNaN(porta) && porta != "") {
        url += ":" + porta;
    }
    if (urlpath.charAt(0) == '/') {
        return url + urlpath;
    } else {
        return url + "/" + urlpath;
    }
}
